import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { CurrentPlatformStepOptions } from './components/CurrentPlatformStepOptions';
import { CurrentPlatformStepInput } from './components/CurrentPlatformStepInput';
import { useAppStore } from 'stores/state';
import { biEvents } from 'api/bi-events';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi-events';
import { StepId } from 'config/flow';

export const CurrentPlatformStep: FC = () => {
  const { t } = useTranslation();

  const currentPlatform = useAppStore((state) => state.currentPlatform);
  const currentPlatformUrl = useAppStore((state) => state.currentPlatformUrl);

  return (
    <StepLayout
      shouldSkip
      title={t('current-platform-step.title')}
      description={t('current-platform-step.description')}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.CurrentPlatform],
          action: BI_ACTION_NAME.NEXT,
          value: JSON.stringify({ currentPlatform, currentPlatformUrl }),
        });
      }}
      nextButtonProps={{
        label: t('current-platform-step.actions.next-button'),
        disabled: !currentPlatform,
      }}
    >
      <CurrentPlatformStepOptions />
      <CurrentPlatformStepInput />
    </StepLayout>
  );
};
